import {z} from 'zod';

const GetNoteResponseBodySchema = z
  .object({
    text: z.string().optional(),
  })
  .nullable();

export const GetNoteApiResponseSchema = z.union([GetNoteResponseBodySchema, z.void()]);
export type CorGetNoteApiApiResponse = z.infer<typeof GetNoteApiResponseSchema>;

export const GetNoteApiArgSchema = z.object({
  contextTarget: z.literal('SERVICE_ORDER'),
  contextId: z.string(),
  context: z.literal('COMMENTS_INTERNAL_NOTE'),
});

export const PutNoteApiResponseSchema = z.void();

const PutNoteRequestBodySchema = z
  .object({
    text: z.string().nullable().optional(),
  })
  .nullable();

export const PutNoteApiArgSchema = z.object({
  contextTarget: z.literal('SERVICE_ORDER'),
  contextId: z.string(),
  context: z.literal('COMMENTS_INTERNAL_NOTE'),
  body: PutNoteRequestBodySchema,
});

export type CorGetNoteApiApiArg = z.infer<typeof GetNoteApiArgSchema>;
export type CorPutNoteApiApiResponse = z.infer<typeof PutNoteApiResponseSchema>;
export type CorPutNoteApiApiArg = z.infer<typeof PutNoteApiArgSchema>;
